<script lang="ts">
    import { getContext } from "svelte"
    import { prettyNumber } from "../../../lib/Utils"
    import Table from "../../../widgets/Table.svelte"
    import TableSorter from "../../../widgets/TableSorter.svelte"
    import Dialog from "../../../widgets/modals/Dialog.svelte"

    const i18n: any = getContext("i18n")
    export var onClose: () => void, stat: any, name: string, period: number
</script>

<Dialog bodyPadding="0px" onClose={() => onClose()}>
    <svelte:fragment slot="title">Hangup Cause</svelte:fragment>
    {#if stat}
        {@const _stat = Array.isArray(stat.Calls) ? Object.fromEntries(Object.keys(stat).map((k) => [k, Array.isArray(stat[k]) ? stat[k][period] : stat[k]])) : stat}
        <b style="margin: 10px; text-align:center;">{name}</b>
        <Table margin="0px 10px 10px 10px">
            <tr slot="head">
                <th>Cause <TableSorter /></th>
                <th>Amount <TableSorter /></th>
                <th>Ratio <TableSorter /></th>
            </tr>
            {#each Object.keys(_stat.HangupCause)
                .map((it) => parseInt(it))
                .sort() as k}
                <tr>
                    <td>{i18n.translate("telephony.hangup-cause." + k) || k}</td>
                    <td data-sort={_stat.HangupCause[k]}>{prettyNumber(_stat.HangupCause[k])}</td>
                    <td data-sort={_stat.Calls > 0 ? (_stat.HangupCause[k] / _stat.Calls) * 100 : 0}>{(_stat.Calls > 0 ? (_stat.HangupCause[k] / _stat.Calls) * 100 : 0).toFixed(1)}%</td>
                </tr>
            {/each}
        </Table>
    {/if}
</Dialog>
